'use client';
import { Anchor, AnchorProps } from '@repo/ui/src/components/Anchor';
import Container from '@repo/ui/src/primitives/Container';
import NavLinks, { LinkProps } from './_NavLinks';
import { classNames } from '@repo/ui/src/utils/classNames';
import { useEffect } from 'react';

interface Props {
  primaryText?: string;
  secondaryText?: string;
  buttonLink?: AnchorProps;
  navLinks?: Array<LinkProps>;
}

const StickyNavWithLinks = ({ navLinks, buttonLink, primaryText, secondaryText }: Props) => {
  useEffect(() => {
    const stickyNavElement = document.querySelector('.sticky-nav-with-links-component');

    if (stickyNavElement) {
      const height = (stickyNavElement as HTMLElement).offsetHeight;
      document.documentElement.style.setProperty('--sticky-nav-height', `${height}px`);
    }

    return () => {
      document.documentElement.style.setProperty('--sticky-nav-height', '0px');
    };
  }, []);

  return (
    <Container
      className="sticky-nav-with-links-component grid grid-cols-[auto_1fr_auto] sticky top-[var(--navTop)] left-0 w-full bg-neutral-800 items-center z-[400] overflow-hidden py-2"
      as="nav"
    >
      <h3 className="tra-text-web-sub-1 text-neutral-50 mr-4">
        {(primaryText || secondaryText) && (
          <span>
            {primaryText} {secondaryText && <span>{secondaryText}</span>}
          </span>
        )}
      </h3>

      <NavLinks
        navLinks={navLinks}
        className={classNames('flex', !primaryText && !secondaryText ? '-ml-4' : '')}
      />

      <div>
        <Anchor
          {...buttonLink}
          className="tra-text-web-utl-button-s bg-brand-400 text-neutral-50 py-3 px-5 transition-all duration-300 hover:bg-brand-400 lg:py-3 lg:px-10"
        >
          {buttonLink?.displayName}
        </Anchor>
      </div>
    </Container>
  );
};

export default StickyNavWithLinks;
